import { deleteData, getData, postData, updateData } from "../../../apis/api.helpers";
import apiUrl from "./api.url";

export const getAddonList = (perPage:number,page:number,search?:string ) =>
  getData(`${apiUrl.ADDON_LIST}?per_page=${perPage}&page=${page}&search=${search}`).then((res) => res.data);

  export const getAddonDetails = (id:string ) =>
  getData(`${apiUrl.ADDON_DETAILS}/${id}`).then((res) => res.data);
